module.exports = __webpack_public_path__ + "static/SquareSerif-Light-webfont-a78dbebae73bb7585de5d94804cb748c.woff";